import styled from 'styled-components';
export const Container = styled.div `
  margin-bottom: 56px;
`;
export const PriceWrapper = styled.div `
  padding-right: 20px;
`;
export const WeightContainer = styled.div `
  max-width: 156px;
  display: flex;
`;
